import React, {Component} from 'react';
const { connect } = require('react-redux');
import Modal from 'react-bootstrap-modal';
import Dropzone from 'react-dropzone';
import {Form, ErrorContainer} from 'form';

import SubmitWrapper from 'components/form/SubmitWrapper';
import ModalFaqBlock from 'components/faq/ModalFaqBlock';

import '../../sass/modals/modalAddPhoto.scss';

import {uploadMemberPhoto, deleteMemberPhoto, saveMemberPhoto} from 'backend-helpers/member';
import {
    ALBUM_CERTIFIED,
    ALBUM_PUBLIC,
    ALBUM_XXL,
    ALBUM_LIMITS
} from '../../constants/memberPhoto';

import {memberPhotoUploaded, memberPhotoDeleted, memberPhotoSaved} from 'reducers/member';

import {t} from 'l10n';

class ModalAddPhoto extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imgFile: null,
            pending: false
        };

        this.deleteMemberPhoto = this.deleteMemberPhoto.bind(this);
        this.onAddClick = this.onAddClick.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onSubmitUpload = this.onSubmitUpload.bind(this);
        this.onSubmitUploadSuccess = this.onSubmitUploadSuccess.bind(this);
        this.onSubmitSave = this.onSubmitSave.bind(this);
        this.onSubmitSaveSuccess = this.onSubmitSaveSuccess.bind(this);
    }

    cleanFile(event) {
        event.preventDefault();
        window.URL.revokeObjectURL(this.state.imgFile.preview);
        this.setState({imgFile: null});
        this.form.cleanErrors();
    }

    deleteMemberPhoto(memberPhoto) {
        let {memberPhotoDeleted, closeFn} = this.props;

        let {id} = memberPhoto;

        deleteMemberPhoto(id)
            .then(() => {
                memberPhotoDeleted(id);
                closeFn();
            })
            .catch((error) => { alert(error.message) })
    }

    onAddClick(event) {
        event.preventDefault();
        this.dropzone.open();
    }

    onDrop(files) {
        this.setState({imgFile: files[0]});
    }

    onSubmitUpload(formData, setErrors) {
        this.setState({pending: true});

        uploadMemberPhoto(formData, this.state.imgFile)
            .then(this.onSubmitUploadSuccess)
            .catch((error) => {
                this.setState({pending: false});
                setErrors(error.message);
        });
    }

    onSubmitUploadSuccess({memberPhoto}) {
        let {memberPhotoUploaded, closeFn, onSuccess} = this.props;

        memberPhotoUploaded(memberPhoto);

        this.setState({
            imgFile: null,
            pending: false
        });

        if (typeof onSuccess === 'function') onSuccess();

        closeFn();
    }

    onSubmitSave(formData, setErrors) {
        saveMemberPhoto(formData)
            .then(this.onSubmitSaveSuccess)
            .catch((error) => {
                this.setState({pending: false});
                setErrors(error.message);
        });
    }

    onSubmitSaveSuccess({memberPhoto}) {
        let {memberPhotoSaved, closeFn} = this.props;

        memberPhotoSaved(memberPhoto);

        this.setState({
            memberPhoto: null,
            pending: false
        });

        closeFn();
    }


    onHide() {
        this.setState({imgFile: null});
        this.props.closeFn();
    }

    render() {
        let {show, closeFn, memberPhoto} = this.props;

        let {imgFile} = this.state;

        let form = null;

        if (!imgFile && !memberPhoto) {
            form = (
                <Dropzone
                    className="add-photo-block"
                    activeClassName="active"
                    onDrop={this.onDrop}
                    ref={(ref) => this.dropzone = ref}
                    multiple={false}
                    disableClick={true}
                >
                    <div>
                        <p>{t('Drag your file here...')}</p>
                        <button onClick={this.onAddClick}>{t('Or add from...')}</button>
                    </div>
                </Dropzone>
            );
        } else if (imgFile) {
            form = (
                <div className="edit-photo-block">
                    <div className="img">
                        <div className="icon-delete" onClick={(event) => this.cleanFile(event)}/>
                        <img src={imgFile.preview} alt="" className="preview"/>
                    </div>
                    <div className="edit-buttons">
                        <SubmitWrapper className="upload-image" value={t('Upload')} pending={this.state.pending}/>
                        <button className="reset" onClick={(event) => this.cleanFile(event)}>{t('Reset')}</button>
                    </div>
                </div>
            );
        } else if (memberPhoto) {
            form = (
                <div className="edit-photo-block">
                    <div className="img">
                        <div className="icon-delete" onClick={() => this.deleteMemberPhoto(memberPhoto)}/>
                        <img src={memberPhoto.thumb_url} alt="" className="preview"/>
                    </div>
                    <div className="edit-buttons">
                        <SubmitWrapper className="upload-image" value={t('Save')} pending={this.state.pending}/>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <Modal className="modaladdPhoto" show={show} onHide={closeFn}>
                    <Modal.Body>
                        <div className="close" onClick={closeFn}/>
                        <p className="modal-title">{memberPhoto ? t('Edit a photo') : t('Add a photo')}</p>
                        <div className="form">
                            <Form onSubmit={!memberPhoto ? this.onSubmitUpload : this.onSubmitSave} ref={(ref) => this.form = ref}>
                                {memberPhoto && <input type="hidden" name="id" value={memberPhoto.id}/>}

                                <ErrorContainer data-errorcontainer={true} />
                                <div className="form-group">
                                    {form}
                                </div>
                                <div className="form-group">
                                    <label className="mini">{t('Status:')}</label>
                                    <div className="selects">
                                        <div className="radio">
                                            <input type="radio" id="select1" name="type" value={ALBUM_PUBLIC} defaultChecked={(memberPhoto && memberPhoto.type == ALBUM_PUBLIC) || true} onClick={() => this.setState({certifiedSelected: false})}/>
                                            <label htmlFor="select1">{t('Public photo')}</label>
                                        </div>
                                        <div className="radio">
                                            <input type="radio" id="select2" name="type" value={ALBUM_XXL} defaultChecked={(memberPhoto && memberPhoto.type == ALBUM_XXL) || false} onClick={() => this.setState({certifiedSelected: false})}/>
                                            <label htmlFor="select2">{t('XXL photo')}</label>
                                        </div>
                                        <div className="radio">
                                            <input type="radio" id="select3"  name="type" value={ALBUM_CERTIFIED} defaultChecked={(memberPhoto && memberPhoto.type == ALBUM_CERTIFIED) || false} onClick={() => this.setState({certifiedSelected: true})}/>
                                            <label htmlFor="select3">{t('Certified photo')}</label>
                                        </div>
                                    </div>
                                </div>
                                {(!memberPhoto && this.state.certifiedSelected) &&
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <input type="checkbox" id="check1" name="blur_faces"/>
                                            <label
                                                htmlFor="check1">{t('Ask administator to blur faces on the photo')}</label>
                                        </div>
                                    </div>
                                }
                                <div className="form-group">
                                    <label className="mini">{t('Description:')}</label>
                                    <textarea name="comments_img" defaultValue={memberPhoto ? memberPhoto.comments : ''}/>
                                </div>
                                {!memberPhoto &&
                                <div className="form-group">
                                    <ModalFaqBlock items={[
                                        t("The uploaded image size should be at least 1024x768."),
                                        t("Public photos are visible to everyone (%1 photos maximum).", ALBUM_LIMITS[ALBUM_PUBLIC]),
                                        t("XXL photos could be opened only by XXL members."),
                                        t("For you, certified Bobeuse and Bobeur, simply attach a photo to your profile that shows you're a fan or an authentic fan Bob TV. This photo must show the name or logo of our favorite site. So you can enter \"Bob TV\" on a sheet of paper, on your skin or put computer screen in front of you... Be imaginative ;-)")
                                    ]}/>
                                </div>
                                }
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

let mapDispatchToProps = {
    memberPhotoUploaded: memberPhotoUploaded,
    memberPhotoDeleted: memberPhotoDeleted,
    memberPhotoSaved: memberPhotoSaved
};

export default connect(null, mapDispatchToProps)(ModalAddPhoto);


// WEBPACK FOOTER //
// ./src/components/modals/ModalAddPhoto.js